class RequestChatService {
  getChats () {
    return apiClient.get('/api/chats/')
  }

  getChat (chatId: string, signal?: AbortSignal) {
    return apiClient.get('/api/chats/{chatId}/', { dynamicKeys: { chatId }, signal })
  }

  sendMessage (chatId: string, content: string, signal?: AbortSignal) {
    return apiClient.post('/api/chats/{chatId}/messages/', { content }, { dynamicKeys: { chatId }, signal })
  }

  markAsRead (chatId: string) {
    return apiClient.post('/api/chats/{chatId}/read/', undefined, { dynamicKeys: { chatId } })
  }
}

export const requestChatService = new RequestChatService()
